import {lazy} from 'react';

export const CollageLazy = lazy(() => import(/* webpackChunkName: "collage" */ '.'));
